import z from "zod";

const validZipRegex = /^\d{5}(-\d{4})?$/;

export const portingFormSchema = z.object({
    eligibilityNumber: z.string()
        .nonempty("Eligibility number is required")
        .trim()
        .refine((s) => s.replace(/\D/g, "").length === 10, {
            message: "Eligibility number must be 10 digits",
        }),
    otherProvider: z.string().optional().nullable(),
    carrier: z.string().nonempty("Please select your current carrier"),
    firstName: z.string().nonempty("First name is required"),
    lastName: z.string().nonempty("Last name is required"),
    billingAddress: z.string().nonempty("Billing address is required"),
    billingAddress2: z.string().optional(),
    city: z.string().nonempty("City is required"),
    state: z.string().nonempty("State is required"),
    zip: z.string()
        .trim()
        .regex(validZipRegex, "Please enter a valid ZIP code")
        .nonempty("ZIP code is required"),
    accountNumber: z.string().nonempty("Account number is required"),
    accountPIN: z.string().nonempty("Account pin is required")
});

export type PortingForm = z.input<typeof portingFormSchema>;